<div #similerFundraisers *ngIf="checkLength()" class="sf-container">
  <div [ngClass]="{'container': !isMobile}">
  <div class="sf-note">
    <span>
      <svg class="trending-icon" viewBox="0 0 48 48" width="24" xmlns="http://www.w3.org/2000/svg" style="margin-right: 5px;"><path d="M32 12l4.59 4.59-9.76 9.75-8-8-14.83 14.83 2.83 2.83 12-12 8 8 12.58-12.59 4.59 4.59v-12z"></path><path d="M0 0h48v48h-48z" fill="none"></path></svg>
    </span>
    {{title}}
  </div>
  <div class="fundraiser-wrapper">
    <ngx-glide [showArrows]="false" [showBullets]="false" [breakpoints]="breakpoints" [perView]="slidesPerView" [bound]="true" [gap]="15">
      <app-widget *ngFor="let item of fundraisers" (click)="goToFundraiser(item.custom_tag)" [widgetData]="item" [currency]="currency"
                  [currencyIcon]="currencyIcon" [amount]="amount" [supporters]="supporters" [utmTags]="{info_4: 'similar'}" [scrollToTop]="true" [config]="config">
      </app-widget>
    </ngx-glide>
  </div>
</div>

</div>
